<template>
    <ul style="list-style-type: none;" class="p-0">
        <li :class="this.validateColor(/^.{8,}$/)">
            <font-awesome-icon icon="fa-solid fa-xmark" v-if="!this.validate(/^.{8,}$/)" />
            <font-awesome-icon icon="fa-solid fa-check" v-if="this.validate(/^.{8,}$/)" /> Terdiri dari minimal 8 karakter
        </li>
        <li :class="this.validateColor(/^(?=.*[a-zA-Z])(?=.*\d).+$/)">
            <font-awesome-icon icon="fa-solid fa-xmark" v-if="!this.validate(/^(?=.*[a-zA-Z])(?=.*\d).+$/)" />
            <font-awesome-icon icon="fa-solid fa-check" v-if="this.validate(/^(?=.*[a-zA-Z])(?=.*\d).+$/)" /> Harus alphanumeric
        </li>
        <li :class="this.validateColor(/^(?=.*[!@#$%^&*()_+{}|[\]\\';:/?.<>,`~])(?=.*[a-zA-Z0-9]).+$/)">
            <font-awesome-icon icon="fa-solid fa-xmark" v-if="!this.validate(/^(?=.*[!@#$%^&*()_+{}|[\]\\';:/?.<>,`~])(?=.*[a-zA-Z0-9]).+$/)" />
            <font-awesome-icon icon="fa-solid fa-check" v-if="this.validate(/^(?=.*[!@#$%^&*()_+{}|[\]\\';:/?.<>,`~])(?=.*[a-zA-Z0-9]).+$/)" /> Harus mengandung karakter khusus seperti @, #, $, dll.
        </li>
        <li :class="this.validateColor(/^(?=.*[A-Z])(?=.*[\W_|\w]).+$/)">
            <font-awesome-icon icon="fa-solid fa-xmark" v-if="!this.validate(/^(?=.*[A-Z])(?=.*[\W_|\w]).+$/)" />
            <font-awesome-icon icon="fa-solid fa-check" v-if="this.validate(/^(?=.*[A-Z])(?=.*[\W_|\w]).+$/)" /> Harus mengandung minimal satu huruf kapital
        </li>
    </ul>
</template>

<script>
export default{
    name: "ChecklistPassword",
    props: {
        data: {
            type: String,
            required: true,
        },
    },
    methods: {
        validate(pattern) {
            if (this.data == "" || this.data == undefined) {
                return false;
            }
            return pattern.test(this.data);
        },
        validateColor(pattern) {
            return {
                "text-danger": !this.validate(pattern),
                "text-success": this.validate(pattern)
            }
        }
    },
}
</script>